import React, { useEffect, useState } from "react";

function ToolFeedback({ onSubmit }) {
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_FLASK_API_URL}/feedback`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        const filtered = data.filter((q) => q.category === "ToolFeedback");
        setQuestions(filtered);
        setLoading(false);
      });
  }, []);

  const handleChange = (id, category, text, value) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [id]: { value, text, category },
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (onSubmit) {
      onSubmit(answers);
      setSubmitted(true);
    }
  };

  if (loading) return <p>Loading feedback questions...</p>;

  return (
    <div>
      <h2>Tool Feedback</h2>
      {submitted ? (
        <p className="success-message">
          Thanks! Your feedback has been submitted successfully.
        </p>
      ) : (
        <form onSubmit={handleSubmit}>
          {questions.map((question) => (
            <div key={question.id} className="feedback-question">
              <label className="feedback-label">{question.text}</label>
              {question.type === "text" ? (
                <input
                  type="text"
                  className="feedback-input"
                  onChange={(e) =>
                    handleChange(
                      question.id,
                      question.category,
                      question.text,
                      e.target.value
                    )
                  }
                />
              ) : question.type === "select" ? (
                <select
                  className="feedback-input"
                  onChange={(e) =>
                    handleChange(
                      question.id,
                      question.category,
                      question.text,
                      e.target.value
                    )
                  }
                >
                  <option value="">Select an option</option>
                  {question.options.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              ) : question.type === "radio" ? (
                <div className="radio-options">
                  {question.options.map((option, index) => (
                    <label key={index} className="radio-label">
                      <input
                        type="radio"
                        name={question.id}
                        value={option}
                        onChange={(e) =>
                          handleChange(
                            question.id,
                            question.category,
                            question.text,
                            e.target.value
                          )
                        }
                      />
                      {option}
                    </label>
                  ))}
                </div>
              ) : null}
            </div>
          ))}
          <button type="submit" className="submit-button">
            Submit Tool Feedback
          </button>
        </form>
      )}
    </div>
  );
}

export default ToolFeedback;
